import { FEATURE_FLAGS, Shop } from "../types/v2";

/**
 * Whether a card move should sync its technician to Tekmetric for this shop.
 * Requires BOTH the internal engineering kill-switch/rollout flag
 * (`Shop.enabledFeatures`) AND the shop admin's own opt-in
 * (`Shop.shopConfig.technicianWritebackEnabled`) — the two are independent
 * booleans by design, not one flag doing double duty, so a shop only sees
 * (and can control) this once we've already turned the engineering flag on
 * for them.
 */
export function isTechnicianWritebackEnabledForShop(shop: Shop): boolean {
  return (
    shop.enabledFeatures?.[FEATURE_FLAGS.isTechnicianWritebackEnabled] ===
      true && shop.shopConfig?.technicianWritebackEnabled === true
  );
}
